import { render, staticRenderFns } from "./HomeLayout.vue?vue&type=template&id=4633e721&scoped=true"
import script from "./HomeLayout.vue?vue&type=script&lang=js"
export * from "./HomeLayout.vue?vue&type=script&lang=js"
import style0 from "./HomeLayout.vue?vue&type=style&index=0&id=4633e721&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4633e721",
  null
  
)

export default component.exports